import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

const escape = (str: string) => {
  if (str !== null) {
    return str.toString().replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  } else {
    return '';
  }
};

@Pipe({
  name: 'highlightSearch'
})
export class HighlightSearchPipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) { }

  transform(value: any, ...args: any): unknown {

    if (!args || value == null) {
      return value;
    }

    // Match in a case insensitive maneer
    const re = new RegExp(escape(args[0]), 'gi');

    const match = value.match(re);

    // If there's no match, just return the original value.
    if (!match) {
      return value;
    }

    const replacedValue = value.replace(re, `<span class="text-link">${match[0]}</span>`);
    return this.sanitizer.bypassSecurityTrustHtml(replacedValue)
  }

}
